export const locale = {
  lang: "en",
  data: {
    mandatory: "Mandatory",
    maintenance:
      "<p>We are currently performing maintenance operations. Please try again later.</p>",
    badBrowser:
      "<p>This website is not supported by Internet Explorer. You can use Chrome, Edge or any other browser.</p>",
    error: {
      generalError: {
        title: "An error occured",
        message:
          "The application has encountered an unexpected problem that prevents it from responding to the request.",
        backToHome: "Back to homepage",
      },
      forbidden: {
        title: "You do not have the permission to view the resource",
        message:
          "The server understood the request but refuses to authorize it.",
        backToHome: "Back to homepage",
      },
      unauthorized: {
        title: "You are not authorized to access the resource",
        message:
          "The request has not been applied because it lacks valid authentication credentials for the target resource.",
        backToHome: "Back to homepage",
      },
      pageNotFound: {
        title: "Oops! Page Not Found",
        message:
          "Sorry but the page you are looking for does not exist, have been removed, name changed or is temporarily unavailable",
        backToHome: "Back to homepage",
      },
      auth: {
        sessionFailure: {
          title: "Your session has expired",
          message:
            "To maintain security, inactive sessions automatically expire. Please reconnect.",
          safariHint:
            'Problems with Safari <img src="https://imgur.com/cBuAiAW.png" alt="Safari" width="30" height="30" /> ?',
          safariMacInstructions:
            'To connect with your Mac, in the Safari app <img src="https://imgur.com/cBuAiAW.png" alt="Safari" width="30" height="30" />, choose <strong>Safari > Preferences</strong>, then click <strong>Privacy</strong> and unselect <strong>"Prevent cross-site tracking"</strong>.',
          safariIosInstructions:
            'To connect with your iPhone/iPad, in the Safari app <img src="https://imgur.com/cBuAiAW.png" alt="Safari" width="30" height="30" />, choose <strong>Safari</strong> in the system <strong>Settings</strong>, then go to the <strong>Privacy et security</strong> section and disable<strong>"Prevent cross-site tracking"</strong>.',
          ok: "Keep working",
          cancel: "Quit",
        },
        signInFailure: {
          title: "SignIn Failure",
          message: "An error occured during authentication.<br>{{errMsg}}",
          ok: "Ok",
        },
        no_authentication_service:
          "No authentication service available. Please contact the ODQ support.",
        cannot_validate_user_permissions: "Unable to validate user permissions",
      },
      file: {
        title: "File",
        message: "An error occured during file download",
      },
    },
    boolean: {
      true: "Yes",
      false: "No",
    },
    emptyStates: {
      companies: {
        tagline: "No partnership or company available",
        hint: "",
      },
      activities: {
        tagline: "No activity for that reference period",
      },
      inscription: {
        tagline: "No inscription form available",
      },
    },
    member: {
      firstName: "Firstname of the ODQ member",
      lastName: "Lastname",
      permitNumber: "Permit number",
    },
    pdf: {
      isLoading: "Your document is loading...",
      unableToDownload: "Unable to download your pdf. Try again later...",
      printableVersion: "Printable version of your {{product}}",
      getPrintableVersion: "Get a printable version (PDF)",
    },
    navigation: {
      back: "Back",
      next: "Next",
      ok: "OK",
      cancel: "Cancel",
      close: "Close",
      retry: "Retry",
      fill: "Fill the form",
    },
    warning: {
      fieldNotSet: "[Not defined]",
    },
    fileUpload: {
      message: {
        header: "Upload",
        succeed: "Upload Succeed!!!",
        failed: "Upload failed",
      },
      dropFileHere: "Drop file here",
      uploadFile: "Upload file",
      uploadAFile: "Upload a file",
      noFile: "No file",
      emptyList: "You did not join any documents",
      fileDetails: {
        filename: "Filename",
        documentType: "Document Type",
        fileTitle: "File Title",
      },
      deleteDialog: {
        title: "Delete a document",
        message: "Are you sure you want to delete this document ?",
      },
    },
    sessionTimeoutDialog: {
      title: "Your session is about to expire",
      message: `For security reasons, your session will expire in 4 minutes.
                Click on the 'Renew session' button to continue working.`,
      buttons: {
        closeDialog: "Close",
      },
    },
    technicalDifficultiesDialog: {
      title: "Error",
      message: `An error occurred during data processing. Please try again.
                If the problem persists, please contact us via our ticket office at <a href:"mailto:billetterie@odq.qc.ca">billetterie@odq.qc.ca</a>.
              `,
      buttons: {
        closeDialog: "Close",
      },
    },
    form: {
      submit: "Save",
      accept: "Accept",
      cancel: "Cancel",
      field: {
        endDate: "End Date",
        startDate: "Start Date",
      },
      type: {
        AnnualDeclaration: "Annual declaration",
        EndOfPractice:
          "Declaration of end of practice within a limited liability partnership or joint-stock company",
      },
      warning: "Warning",
      validateWithAcountant:
        "<span class='text-danger font-weight-bold'>VALIDATE</span> the information in this section with your legal representative or counsel.",
      changeDate: "Change date",
      save: "Save",
      reset: "Reset form",
      lastSave: "Last save",
      completed: "Your declaration is completed",
      validation: {
        email: "Incorrect email format",
        required: "Required field",
        selectionRequired: "Choose a value in the list",
        more_than_point_five: "Value must be greater than 0.5",
        adressFormat: "Choose an address in the list",
        positive: "Value must be greater or equal to 0",
        fileMaxSize:
          "The maximum size of the file must be less or equal than 250 Mb",
      },
      saveToast: {
        title: "Save",
        message: "Modifications are currently saving, please wait",
      },
      initToast: {
        title: "Reinitialization",
        message: "Form is curently resetting, please wait",
      },
      previousStep: "Previous Step",
      nextStep: "Next Step",
      uploadDocument: "Upload Documents",
      annual: {
        declaration: {
          document: {
            Other: "Other Document",
            CertifiedCopyAmendingDeclarationWithNEQ:
              "Certified copy of any amending declaration filed with the REQ",
            CopyCertificateAmalgamationIssuedByREQ:
              "Copy of the certificate of amalgamation issued by the REQ",
            CopyDeclarationShortFormMergerFiledWithREQ:
              "Copy of the declaration of short-form merger filed with the REQ",
            CopyCertificateAmalgamationIssuedInnovationScienceAndEconomicDevelopmentCanada:
              "Copy of the certificate of amalgamation issued by Innovation, Science and Economic Development Canada",
            CopyAnyCertificateNameChangeIssuedByREQ:
              "Copy of any certificate of name change issued by the REQ",
            DeclarationFiledWithREQAttestingNameChange:
              "Declaration filed with the REQ attesting to the name change",
            CertificateNameChangeIssuedByCorporationsCanada:
              "Certificate of name change issued by Corporations Canada",
            OriginalFormAgreementBetweenDentistTransferringRecordsAndDentistReceivingTransferredRecords:
              "Original of the form for an Agreement between a dentist transferring records and the dentist receiving transferred records",
            CompanyInformationStatementAtREQ:
              "Company's information statement (REQ)",
          },
          summaryDialog: {
            workingCopy: "Working copy",
            submittedCopy: "Version submitted to ODQ",
          },
          fileNumber: "File number",
          title: "Annual Declaration",
          summary: "Summary and Attestation",
          attestation: "Attestation",
          summaryContent: {
            mandatedIdentification: {
              title: "Respondent member or mandated representative",
              filledBy: "Declaration filled by : ",
              name: "Name and surname",
              email: "Email",
              date: "Date",
              representative: "a mandated representative",
              respondent: "the respondent member",
            },
            warning2:
              "<span class='importantText'>* Note:</span> <br><br>A summary of your declaration in PDF format will soon be available.<br><br>In the next few weeks, you will receive an email informing you that this summary is available. You will then be able to access and print it for your records by going to the Order’s portal under \"Partnership or company.\"<br><br>Once you have clicked this button, you will not be able to return to the previous sections or to modify the form.",
            operation: "Operation",
            section1: {
              area_2: {
                msgName: "Name",
              },
              area_4: {
                member: "Member",
              },
            },
            section3: {
              type: "Type",
            },
            section4: {
              shareholderOdqMember: "Shareholder –ODQ member",
            },
            section5: {
              odqMemberTitle: "Shareholder(s)/trustee(s) - ODQ member(s)",
              spouseReactiveTitle:
                "Shareholder(s)/trustee(s) - Spouse/relative(s)",
              members: "ODQ Member(s)",
              spouses: "Spouse/Relative(s)",
              shareholders: "Shareholder(s)",
              trustees: "Trustee(s)",
            },
            section6: {
              title: "Uploaded documents",
              noUploadDocument: "No documents to upload.",
            },
          },
          uploadDocument: "Annual Declaration File Upload",
          tabLabel: {
            companyInformation: "Company Information",
            membersVoting: "Voting Members",
            legalPersonVoting: "Voting Legal Persons",
            naturalPersonNonVoting: "Non-Voting Natural Persons",
            legalPersonNonVoting: "Non-Voting Legal Persons",
          },
          directive: {
            title: "Instructions",
            p1: "Section 187.11 of the Professional Code (RSQ, c. C-26) states that members may carry out their professional activities within a limited liability partnership or a joint-stock company constituted for that purpose provided they furnish the Ordre des dentistes du Québec (the “Order”) with a declaration to this effect in accordance with the requirements prescribed in the Regulation respecting the practice of the dental profession in a limited liability partnership or a joint-stock company (hereinafter the “Regulation”). Section 4 of the Regulation requires that this Declaration be provided to the Order prior to carrying out their activities.",
            p2: "As for section 6, it requires that said Declaration be updated before March 31 of each year. Moreover, as soon as there is a change in the information described in this Declaration and subsequent updates, members must promptly inform the Order using the appropriate form. Lastly, all the conditions set out in the Regulation as well as in Chapter VI.3 of the Professional Code must be respected at all times by the members and the partnership or company.",
            p3: "If you fail to file the appropriate documents, section 1 of the Regulation stipulates that:",
            quote:
              "« A member who no longer satisfies one of the conditions set out in this Regulation or in Chapter VI.3 of the Professional Code shall immediately cease to be authorized to practise the profession within a partnership or company. »",
            odq_1:
              "You must notify the Order immediately when changes affecting the distribution of shares occur (Regulation, section 6).",
            odq_2:
              "Any error or omission may result in delay in processing your application or in the entry of information in the Order’s register of partnerships and companies.",
          },
          amendedDeclaration: "Amended Declaration",
          annualDeclarationWithAmendments:
            "Annual declaration with amendments as of {{annualDate}}",
          viewSummary: "Summary",
          downloadNotice: "Directives",
          section1: {
            title: "Partnership or Company Information",
            area1_1: {
              title: "Identification of Partnership or Company",
              titleHtml:
                "Identification of Partnership or Company <span class='importantText small-text-normal'>(Required Field)</span>",
              PartnershipCompanyName: "Partnership or Company Name",
              QuebecEnterpriseNumber: "Quebec Enterprise Number (NEQ)",
            },
            area1_2: {
              title: "Address of head office",
              titleNote:
                "<span class='text-danger small-text-normal'>(Complete only if changed)</span>",
              address: {
                Line1: "Line 1",
                Line2: "Line 2",
                City: "Municipality / City / Town",
                Prov: "Province / State",
                PostalCode: "Postal Code",
                Country: "Country",
              },
            },
            area2: {
              title:
                "Other Partnership or Company Names Used And Declared to the REQ",
              note: "<span class='font-weight-bold'>N.B.</span>",
              noteDetail:
                "In all cases, the names must also have been registered with the REQ.",
              otherName: "Other Name",
              addition: "addition",
              deletion: "deletion",
              addOtherCompany: "Add Other Name",
              removeOtherName: "Remove the other name {{otherName}}",
              endDate: "End date",
              warning:
                "<p>ALL names used to designate the company MUST be registered with the Order. If applicable, <span class='font-weight-bold'>declare ANY MODIFICATION</span> made with the REQ (addition/removal) to the list of names below.</p><p>Subject to sections 3.09.01 and subsequent sections of the Code of Ethics and section 36 of the Dental Act, the Order <span class='font-weight-bold'>reserves the right to require the removal of any name and/or other name that violates these sections.</span></p><p>The use of a name and/or other name not approved by the Order may have an impact on the authorization granted to the company. </p>",
            },
            area3: {
              title: "Representative / Substitute representative",
              information:
                "<ol class='numberedList'><li>The representative/substitute representative <span class='font-weight-bold'>MUST</span> carry on his/her professional activities in Quebec within the partnership or company for which he/she is acting in this capacity.</li><li>When, for an establishment of the partnership/company, <span class='font-weight-bold'>NO</span> shareholder/partner carries on professional activities there, a member of the Order <span class='font-weight-bold'>MUST</span> nonetheless be designated to act in this capacity for each of the establishments concerned (e.g. self-employed worker, employee).</li><li>The representative(s) <span class='font-weight-bold'>MUST</span> sign the <span class='font-weight-bold'>Confirmation of acceptance by representative</span>, below.</li><li>When a representative <span class='font-weight-bold'>CEASES</span> to be the <span class='font-weight-bold'>designated </span>person for acting in this capacity, he/she <span class='font-weight-bold'>MUST</span> ensure that a new representative is <span class='font-weight-bold'>designated </span>and submit a new <span class='font-weight-bold'>Confirmation of acceptance by representative</span> to the Order.</li></ol>",
              informationNote:
                "<span class='font-weight-bold text-danger'>N.B.: </span> A <span class='font-weight-bold text-danger'>substitute representative</span> per establishment must be designated <span class='font-weight-bold'>only</span>  if more than one member of the Order is carrying on professional activities within the partnership or company.",
              convention: {
                title: "CONFIRMATION OF ACCEPTANCE BY REPRESENTATIVE",
                note: {
                  header: "N.B",
                  information:
                    "The mailing address chosen by the representative/substitute in his/her Annual Declaration will be used for any correspondence with the partnership or company.",
                },
              },
              warning:
                "<ol><li>The representative/substitute representative <span class='font-weight-bold'>MUST</span> carry on his/her professional activities in Quebec within the partnership or company for which he/she is acting in this capacity.</li><li>When, for an establishment of the partnership/company, <span class='font-weight-bold'>NO</span> shareholder/partner carries on professional activities there, a member of the Order <span class='font-weight-bold'>MUST</span> nonetheless be designated to act in this capacity for each of the establishments concerned (e.g. self-employed worker, employee).</li><li>If not yet done, the <span class='font-weight-bold'>Confirmation of acceptance by representative</span> form MUST BE completed jointly with one of the shareholders and <span class='font-weight-bold'>UPLOADED</span> under section 8 of the declaration.  </li><li>When a representative <span class='font-weight-bold'>CEASES</span> to be the designated person for acting in this capacity, he/she <span class='font-weight-bold'>MUST</span> ensure that a new representative is designated and submit a new Confirmation of acceptance by representative to the Order. </li></ol><p>The <span class='font-weight-bold'>Confirmation of acceptance by representative</span> form is available at <a  target='blank' href='www.odq.qc.ca'>www.odq.qc.ca</a>, under the Studies and Permit Applications – Practice within a partnership or company section.</p><p><span class='font-weight-bold'>N.B.:</span> A <span class='font-weight-bold'>substitute representative</span> per establishment must be designated only if more than one member of the Order is carrying on professional activities within the partnership or company OR when the representative is not carrying on professional activities in ALL the establishments OPERATED by the company. </p>",
              area3_1: {
                nameMemberAnsweringRequiredTitle:
                  "Representative's name <span class='importantText small-text-normal'>(Required field)</span>",
                nameMemberAnswering: "Representative’s Name",
                licenseNumber: "Permit Number",
                nochange: "No change",
                change: "Amendment",
                question:
                  "<span class='importantText'>Do you practise the profession within the partnership/company?</span>",
                questionTitle:
                  "Do you practise the profession within the partnership/company?",
                yes: "Yes",
                no: "No",
                noNote:
                  "A <span class='font-weight-bold'>Confirmation of acceptance by representative</span> must be signed by each representative for each establishment of the partnership/company.",
                nameMemberAnsweringSubstitutTitle:
                  "Substitute representative's name <span class='importantText small-text-normal'>(If applicable)</span>",
                nameMemberAnsweringSubstitut:
                  "Substitute Representative’s Name",
                article_1:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> I attest that I am a member of the Order and that I have been appointed to act on behalf of all members practising therein in order to satisfy the conditions provided in sections 6 and 8.",
                article_2:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> I attest that when I accepted these duties I ensured the accuracy of all information to be provided to the Order and I agree to respond to requests made by the syndic, an inspector, an investigator or any other Order representatives.",
                article_3:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> Furthermore, I authorize the persons, committees, disciplinary bodies and tribunals contemplated in section 193 of the Professional Code to require any partner or shareholder to communicate and obtain any of the documents mentioned in section 13 of the Regulation or a copy thereof.",
                article_4:
                  "<i class='fa fa-check fa-lg text-dark pt-2 pr-2'></i> I attest that I have been duly informed of my obligation to immediately submit the appropriate form if I resign from my position as representative.",
                attestation: "Attestation",
                attestationRequired: "The attestation is required",
                attestationInfo:
                  "By checking off this box, I, Dr. {{memberName}}, have duly filled out the “Confirmation of acceptance by representative”, and I affirm that all of the information provided is accurate and truthful, on {{attestationDate}}",
              },
            },
            area4: {
              title:
                "Name and address of business establishment in Quebec and name of each ODQ member working there as an employee/self-employed worker",
              establishmentInformation:
                "For each establishment, identify a representative/substitute representative, shareholders/partners and employees/self-employed workers, who are ODQ members, working there.",
              institution: {
                exploitedByLegalEntity:
                  "This establishment is exploited by legal entity",
                notExploitedByLegalEntity:
                  "This establishment is not exploited by legal entity",
                isExploitedByLegalEntity: "Exploited by legal entity",
                addInstitution: "Addition/establishment",
                removeInstitution: "Deletion/establishment",
                editInstitution: "Amendment/establishment",
                name: "ESTABLISHMENT",
                address: {
                  No: "No",
                  Street: "Street",
                  City: "Municipality / City / Town",
                  Prov: "Province / State",
                  PostalCode: "Postal Code",
                  Country: "Country",
                },
                nameInstitution: "Name of the Establishment",
                addInstitutionButton: "Add Other etablishment",
                memberList: {
                  title:
                    "List of all ODQ members practising within the partnership/company in this establishment",
                  nameMember: "ODQ Member's First Name, Last Name",
                  permitNumber: "Permit Number",
                  status: "Status(es)",
                  addMember: "Add",
                  removeMember: "Delete",
                  removeThisMember: "Remove this member",
                  amendmentMember: "Amend",
                  addMemberButton: " Add Other member",
                  responsibility: "Responsibility",
                  responsibilityOptions: {
                    Primary: "Respondent for the establishment",
                    Substitute: "Substitute respondent for the establishment",
                    None: "N/A",
                  },
                  state: "State",
                  stateOptions: {
                    Administrator: "Administrator",
                    Employee: "Employee",
                    SelfEmployed: "Self employed",
                  },
                },
              },
              warning:
                "<p><span class='font-weight-bold'>Establishment <span class='text-danger'>OPERATED</span> by the company</span><br>A company <span class='font-weight-bold text-danger'>OPERATING</span> an establishment refers to a physical location where professional activities are carried on. This establishment MUST be registered in this section.</p><p><span class='font-weight-bold'>Establishment <span class='text-danger'>NOT OPERATED</span> by the company</span><br>Conversely, a company <span class='font-weight-bold text-danger'>NOT OPERATING</span> an establishment is one that only receives fees from the professional activities being carried on. This establishment DOES NOT need be registered in this section</p><p><span class='font-weight-bold'>All</span> addresses listed in this section <span class='font-weight-bold'>will be listed in the</span> Order’s <span class='font-weight-bold'>Company Register only.</span></p><p><span class='font-weight-bold'>Section 60 of the Professional Code</span><br>Each member of the Order carrying on activities in establishments declared under this section <span class='font-weight-bold'>is responsible for the update of ALL addresses</span> on the roll where he or she is carrying on activities.</p>",
            },
            area5: {
              title: "Number of directors",
              titleHtml:
                "<span class='text-danger small-text-normal''>(Required Field)</span>",
              note: "<span class='font-weight-bold'>N.B</span>",
              noteDetail:
                "<span class='font-weight-bold'>Only members of the Order may be appointed to carry out management duties within the partnership or company, including, if applicable, the duties of director, officer and representative.</span>",
              information:
                "Number of directors on the board of directors of the joint-stock company or on the internal management board of the limited liability partnership:",
              numberAdmin: "Number of directors",
            },
            area6: {
              title:
                "Number and distribution of voting partnership or company shares",
              note: "<span class='text-danger'>N.B. Complete if there is a change on section 3 or 4 of this form.</span>",
              number_1: `Number of voting partnership or company shares held only by ODQ members:`,
              number_2:
                "Number of voting partnership or company shares held by trusts or any other enterprise:",
              number_3:
                "TOTAL number of voting partnership or company shares issued by the partnership or company:",
            },
            area7: {
              title:
                "Number and distribution of non-voting partnership or company shares",
              note: "<span class='text-danger'>N.B. Complete if there is a change on section 5 or 6 of this form.</span>",
              number_1:
                "Number of non-voting partnership or company shares held by ODQ members and/or spouse and/or a family member:",
              number_2:
                "Number of non-voting partnership or company shares held by trust or any other enterprise:",
              number_3:
                "TOTAL number of non-voting partnership or company shares issued by the partnership or company:",
            },
          },
          section2: {
            title:
              "Information on members holding VOTING partnership or company shares",
            titleHtml:
              "Information on members holding VOTING partnership or company shares",
            areaTitle: "MEMBER",
            addition: "addition",
            deletion: "deletion",
            amendment: "amendment",
            numberVoting: "Number of voting partnerships or company shares?",
            startDate: "Effective Date",
            endDate: "End Date",
            firstName: "First Name",
            lastName: "Member's Last Name",
            or: "OR",
            yes: "I attest and confirm that this person contributes to the FARPODQ and is not exempted therefrom. I undertake to immediately notify the Order in writing should this coverage be interrupted for any reason whatsoever.",
            no: "I attest and confirm that on this date this person is entered on the Roll of the ODQ in the “retired member” or “exempted from FARPODQ liability insurance” category.",
            personPractise:
              "<span class='text-danger font-weight-bold'>Does this person practise within the partnership or company?</span>",
            personPractiseTitle:
              "Does this person practise within the partnership or company?",
            adressTitle: "Within the partnership or company :",
            status:
              "Status(es) or function(s) within the partnership or company <span class='text-danger'>(check all applicable boxes)</span>",
            statusTitle:
              "Status(es) or function(s) within the partnership or company",
            shareholder: "Shareholder",
            partner: "Partner",
            officer: "Officer",
            director: "Director",
            employee: "Employee",
            management: "Management duties",
            addMemberButton: "Add Other member",
            removeThisMember: "Remove this member",
            warning:
              "In this section, the aggregate of <span class='font-weight-bold'>voting rights attached to partnership or company shares <span class='font-weight-bold'>is held</span> by <span class='font-weight-bold'>At least one MEMBER OF THE ORDER ONLY</span>",
          },
          section3: {
            addMemberButton: "Add Other Member Shareholder",
            title:
              "Information on legal persons, trusts and other companies holding VOTING shares in the partnership or company",
            titleHtml:
              "Information on legal persons, trusts and other companies holding VOTING shares in the partnership or company",
            areaTitle: "LEGAL FORM/TRUST",
            warning:
              "<p>In this section, the aggregate of <span class='font-weight-bold'>voting rights</span> attached to partnership or company shares is held by: </p><ul><li><span class='font-weight-bold'>Legal person/other enterprise</span><p>The legal person or any other enterprise <span class='font-weight-bold'>whose voting rights attached to the voting shares</span> of the partnership or company identified in section 2.1, or to equity shares or other entitlements <span class='font-weight-bold'>ARE HELD WHOLLY by at least one member of the Order ONLY.</span></p></li><p><span class='text-danger font-weight-bold'>OR</span></p><li><span class='font-weight-bold'>Family trust</span><p><span class='font-weight-bold'>The TRUSTEE(S)</span> (not the beneficiaries) of a family trust whose <span class='font-weight-bold'>voting rights</span> attached to the voting shares of the company identified in section 2.1 or to equity shares <span class='font-weight-bold'>MUST BE a member/members of the Order ONLY.</span></p></li></ul>",
            group1_1: {
              add: "addition",
              remove: "deletion",
              edit: "amendment",
            },
            group1_2: {
              person: "Legal person",
              trust: "Trust",
              company: "None",
            },
            group1_3: {
              label: "Number of voting shares?",
            },
            group1_4: {
              startDate: "Effective Date",
              endDate: "End Date",
            },
            group2: {
              name: "Name of Legal Entity/Trust",
              neq: "Quebec Enterprise Number (NEQ)",
            },
            group3: {
              title: "HEAD OFFICE",
            },
            group4: {
              title:
                "STATUS(ES) OR FUNCTION(S) WITHIN THE PARTNERSHIP OR COMPANY HOLDER(S) OF SHARES IN THE LEGAL ENTITY/TRUSTEES <span class='importantText small-text-normal'>(CHECK ALL APPLICABLE BOXES)</span>",
              numberOfTrustees:
                "If applicable, indicate the number of trustees in the trust:",
              odqPermit: "ODQ permit number",
              odqMember: "ODQ member",
              odqPermitPlaceholder: "No.",
              roles: {
                partner: "Partner",
                shareholder: "Shareholder",
                trustee: "Trustee",
                director: "Director",
                officer: "Officer",
                employee: "Employee",
                managementDuties: "Management Duties",
                practicesWithinPartnersip:
                  "Practises within the partnership/ company",
              },
              addStatus: "Add Other status/function",
            },
            addLegalForm: "Add Other legal form/trust",
            summaryDialog: {
              countOfTrusteesError:
                "Please provide all trustees before next step.",
              votingPartsCountError:
                "Total sum of voting shares percentages should equal 100%. Please adjust informations in step 3 and 4",
              votingPartsCountSucces:
                "Total sum of voting shares equal 100%, you can go to next step.",
              adjust: "Adjust",
              nextStep: "Next step",
            },
          },
          section4: {
            title:
              "Information on natural persons with NON-VOTING partnership or company shares",
            titleHtml:
              "Information on natural persons with NON-VOTING partnership or company shares",
            areaTitle: "NATURAL PERSONS",
            warning: {
              title:
                "In this section, in the case of a joint-stock company, the aggregate of <span class='font-weight-bold'>non-voting shares</span> is held by:",
              list: "<ul><li>a member of the Order;</li><li>the spouse of a member of the Order who holds the shares;</li><li>a relative, either by direct or indirect line of descent, of a member of the Order who holds the shares.</li></ul>",
            },
            group1_1: {
              add: "addition",
              remove: "deletion",
              edit: "amendments",
            },
            group1_2: {
              label: "Number of non-voting shares?",
            },
            group1_3: {
              odqPermitNumber: "ODQ Member Permit Number",
              startDate: "Effective Date",
              endDate: "Ending Date",
            },
            group2: {
              shareholderLastName: "Shareholder’s Last Name",
              shareholderFirstName: "First Name",
            },
            group3: {
              title: "Residential Address",
              titleSummary: "Residential Address",
            },
            group4: {
              title:
                "STATUS(ES) OR FUNCTION(S) IN THE PARTNERSHIP OR COMPANY <span class='importantText small-text-normal'>(CHECK ALL APPLICABLE BOXES)",
              odqMember: {
                title:
                  "<b>Shareholder – <span class='text-danger'>ODQ member</span></b>",
                director: "Director",
                officer: "Officer",
                managementDuties: "Management duties",
              },
              spouseOrRelative: {
                title:
                  "<b>Shareholder – <span class='importantText'>Spouse/relative</span></b>",
                subtitle: "RELATIONSHIP WITH ODQ MEMBER SHAREHOLDER",
                relatedToMember: "Related to member",
                relationship: "What Relationship?",
                relationships: {
                  Spouse: "Spouse",
                  Son: "Son",
                  Daughter: "Daughter",
                  Father: "Father",
                  Mother: "Mother",
                  Sister: "Sister",
                  Brother: "Brother",
                  Cousin: "Cousin",
                },
              },
            },
            addPerson: "Add Other natural person",
            memberOrParentEnum: {
              member: "Member of the Order",
              parent: "Spouse/relative of a member",
            },
          },
          section5: {
            title:
              "Information on legal persons, trusts and other companies holding NON-VOTING partnership or company shares",
            titleHtml:
              "Information on legal persons, trusts and other companies holding NON-VOTING partnership or company shares",
            addPerson: "Add Other natural person",
            warning: {
              title:
                "In this section, in the case of a joint-stock company, the aggregate of non-voting shares is held by:",
              point_1_li:
                "<p class='font-weight-bold'>Legal person/other company</p><p>The legal person or any other enterprise <span class='font-weight-bold'>whose voting rights attached to the shares</span> of the partnership or company identified in section 2.1, or to equity shares or other entitlements <span class='font-weight-bold'>ARE HELD WHOLLY by</span></p>",
              point_1_sublist:
                "<ul><li>a member of the Order;</li><li>the spouse of a member of the Order who holds the shares;</li><li>a relative, either by direct or indirect line of descent, of a member of the Order who holds the shares.</li></ul>",
              or: "OR",
              point_2_li:
                "<p class='font-weight-bold'>Family trust</p><p>The <span class='font-weight-bold'>TRUSTEE(S)</span> (and not the beneficiaries) of a family trust holding <span class='font-weight-bold'>non-voting company shares MUST BE:</span></p>",
              point_2_sublist:
                "<ul><li>a member of the Order;</li><li>the spouse of a member of the Order who holds the shares;</li><li>a relative, either by direct or indirect line of descent, of a member of the Order who holds the shares.</li></ul>",
            },
            identification: {
              title: "LEGAL FORM/TRUST",
              legalForm: {
                legalPerson: "Legal person",
                trust: "Trust",
                otherCompany: "Other company",
                none: "None",
              },
              legalFormOperation: {
                add: "addition",
                deletion: "deletion",
                amendments: "amendments",
              },
              numberNonVotingShares: "Number of non-voting shares?",
              effectiveDate: "Effective Date",
              endingDate: "Ending Date",
              legalEntityName: "Name of Legal Entity/Trust",
              neq: "Quebec Enterprise Number (NEQ)",
            },
            headOffice: {
              title: "HEAD OFFICE",
              titleSummary: "Head Office",
              address: {
                no: "No",
                street: "Street",
                city: "Municipality / City / Town",
                prov: "Province / State",
                postalCode: "Postal Code",
                country: "Country",
              },
            },
            countOfTrusteesError_part1: "You indicated ",
            countOfTrusteesError_part2: " trustees but only declared ",
            countOfTrusteesError_part3: ".",
            shareholders: {
              title:
                "STATUS(ES) OR FUNCTION(S) IN THE PARTNERSHIP OR COMPANY OF HOLDER(S) OF SHARES IN THE LEGAL ENTITY/TRUSTEES",
              trusteeInTrust:
                "IF APPLICABLE, INDICATE THE NUMBER OF TRUSTEES IN THE TRUST:",
              trusteeInTrustSummary:
                "If applicable, indicate the number of trustees in the trust:",
              subtitle: {
                shareholder: "Shareholder(s)",
                trustee: "Trustee(s)",
                ofTrust: "of trust",
                ofLegalPerson: "of legal person",
                ofOtherCompany: "of other company",
              },
              odqMember: {
                title: "<span class='text-danger'>ODQ member(s)</span>",
                name: "Name of ODQ Member",
                permitNumber: "ODQ Member Permit Number",
                type: {
                  shareholder: "Shareholder",
                  trustee: "Trustee",
                  director: "Director",
                  officer: "Officer",
                  managementDuties: "Management duties",
                },
                addOdqMember: "Add an ODQ member",
              },
              spouseRelative: {
                title: "<span class='text-danger'>Spouse/relative(s)</span>",
                name: "Name of Shareholder/Trustee Spouse/Relative",
                firstName: "First name of Spouse/Relative",
                lastName: "Last name of Spouse/Relative",
                permitNumber: "ODQ Member Permit Number",
                type: {
                  shareholder: "Shareholder",
                  trustee: "Trustee",
                  spouse: "Spouse",
                  relative: "Relative",
                },
                relationType: "What Relationship?",
                addSpouseRelative: "Add Spouse/Relative",
              },
            },
            summaryDialog: {
              nonVotingPartsCountError:
                "Total sum of non-voting shares percentages should equal 100%. Please adjust informations in step 5 and 6",
              nonVotingPartsCountSucces:
                "Total sum of non-voting shares equal 100%, you can go to next step.",
            },
          },
          section6: {
            title: "Sworn attestations and authorization",
            titleHtml: "Sworn attestations and authorization",
            subtitle:
              "ATTESTATION, IRREVOCABLE WRITTEN AUTHORIZATION AND SWORN STATEMENT",
            representative:
              "REPRESENTATIVE’S / SUBSTITUTE REPRESENTATIVE’S NAME (FIRST, LAST)",
            permitNumber: "PERMIT NUMBER",
            attest:
              "Attest that I am a member of the Order and, if applicable, the person authorized by the partnership or company to sign this Declaration, and that the information contained herein is complete, true and accurate and that the required documents are provided with this Declaration. I further attest that the holding of the partnership or company shares and the administration rules of the partnership or company comply with the conditions of the Regulation.",
            authorize:
              "Authorize the persons, committees, disciplinary bodies and tribunals contemplated in section 192 of the Professional Code to require any partner or shareholder to communicate and obtain any of the documents mentioned in section 13 of the Regulation or a copy thereof.",
            signedSworn: "Signed and sworn before me:",
            signTown: "in (city / town)",
            signDate: "this",
            representativeSign:
              "SIGNATURE OF REPRESENTATIVE / SUBSTITUTE REPRESENTATIVE",
            oathCommissionSign: "SIGNATURE OF THE COMMISSIONER FOR OATHS",
            oathCommissionDistrict: "District",
            oathCommissionTitle: "COMMISSIONER FOR OATHS",
            oathCommissionText:
              "This form may be sworn to before a lawyer, notary or commissioner for oaths.If you choose to have it sworn to before a commissioner for oaths, here is a link to help you find one in your area:<br>http://www.assermentation.justice.gouv.qc.ca/ServicesPublicsConsultation/Commissaires/Proximite/Criteres.aspx",
          },
          section7: {
            mandatoryDocumentWarning:
              "<span class='text-danger font-weight-bold'>MANDATORY FOR ALL COMPANIES: You must upload an updated copy of your compagny’s Information Statement, which you can obtain by performing a search on the Website of the <a target='blank' href='https://www.registreentreprises.gouv.qc.ca/RQAnonymeGR/GR/GR03/GR03A2_19A_PIU_RechEnt_PC/PageRechSimple.aspx?T1.CodeService=S00436&Clng=F&WT.co_f=28f055c33672fe69fc31614102068356'>Registraire des entreprises du Québec (REQ)</a>, by clicking <a target='blank' href='https://www.registreentreprises.gouv.qc.ca/RQAnonymeGR/GR/GR03/GR03A2_19A_PIU_RechEnt_PC/PageRechSimple.aspx?T1.CodeService=S00436&Clng=F&WT.co_f=28f055c33672fe69fc31614102068356'>HERE</a>.</span>",
            documentType: {
              Other: "Other documentation",
              AnyCertNameChByReq: "Any name change certificate issued by REQ",
              CertAmendDeclWithReq:
                "Current updating declaration submitted filed with the REQ",
              CertAmalgByReq: "Amalgamation certificate issued by REQ",
              CertAmalgByIsde:
                "Certificate of amalgamation issued by Corporation Canada",
              CertNameChByCorpsCan:
                "Certificate of name change issued by Corporations Canada",
              DeclAttestNameChWithReq:
                "Name change attestation declaration filed with REQ",
              DeclShortFormMergerWithReq:
                "Short-form merger declaration filed with REQ",
              OrigFrmAgreemtDentistRecsXfer:
                "Original form agreement between a dentist transferring records and the records receiver",
              ConfirmationAcceptanceRepresentative:
                "Confirmation of acceptance by representative",
              CompanyInformationStatementAtREQ:
                "Company's information statement (REQ)",
            },
            documentList: {
              typeName: "Document type",
              savedAt: "Date",
              savedBy: "Saved by",
              upload: "Download",
              remove: "Remove",
            },
          },
        },
      },
      endOfPractice: {
        document: {
          copyCertificateAmalgamationIssuedREQOrOtherAuthority:
            "Copy of the certificate of amalgamation issued by the REQ or any other competent authority",
          copyAmendingDeclarationAttestingAmalgamationFiledWithREQOrOtherAuthority:
            "Copy of any amending declaration or updating declaration attesting to the amalgamation and filed with the REQ or any other competent authority",
        },
        tabTitle: "Declaration of End Of Practice",
        title:
          "Declaration of end of practice within a limited liability partnership or joint-stock company",
        directive: {
          startModification: {
            title: "Start modification",
            subTitle:
              "By selecting this, you will be redirect to the Declaration of End Of Practice section",
          },
        },
        directiveTitle: "Instructions",
        endOfPractice:
          "Declaration of end of practice within a limited liability partnership or joint-stock company <span class='text-danger small-text-normal'>(ATTACH A CHEQUE FOR ADMINISTRATIVE FEES)</span>",
        endOfPracticeAnnual:
          "End of practice within a limited liability partnership or joint-stock company - Annual Declaration as at {{annualDate}}, <span class='text-danger small-text-normal'>(ATTACH A CHEQUE FOR ADMINISTRATIVE FEES)</span>",
        directiveNote:
          "<span class='text-danger font-weight-bold'>FEES: See the table of Fees and penalties at www.odq.qc.ca, in the “Studies and Permit Applications – Practice within a partnership or a company” section.</span>",
        section0: {
          title: "Partnership or Company Information",
          area1: {
            title: "Identification of Partnership or Company",
            nameOfPartnership: "Name of Partnership or Company",
            neq: "Quebec Enterprise Number (NEQ)",
          },
          area2: {
            title: "Effective Date",
          },
          area3: {
            title: "Reason",
            notes:
              "Please check the applicable reason and, if necessary, complete the appropriate section of this form.",
            rowA: "Change in the nature of activities",
            rowAHtml:
              "Change in the nature of activities <span class='text-danger'>(COMPLETE SECTION 1)</span>",
            rowB: "Sale of shares",
            rowBHtml:
              "Sale of shares <span class='text-danger'>(COMPLETE SECTION 2)</span>",
            rowC: "Short-form/long-form amalgamation",
            rowCHtml:
              "Short-form/long-form amalgamation <span class='text-danger'>(COMPLETE SECTION 3)</span>",
            rowD: {
              title: "Voluntary cancellation",
              titleHtml:
                "Voluntary cancellation <span class='text-danger'>(UPON REQUEST)</span>",
              point1:
                "Attach a copy of any declaration filed with the competent authority (e.g. Registraire des entreprises du Quebec [REQ], Corporations Canada)",
            },
            rowE: {
              title: "Liquidation/dissolution",
              point1:
                "Attach a copy of the certificate of dissolution issued by the competent authority, as applicable",
              point2:
                "Attach a copy of any declaration filed with the competent authority (e.g. REQ, Corporations Canada)",
            },
            rowF: {
              title: "Assignment for the benefit of creditors, bankruptcy",
              point1:
                "Attach a copy of any declaration filed with the competent authority (e.g. REQ, Corporations Canada) or any official document attesting to the effective date of cessation of operations.",
            },
          },
        },
        section1: {
          title: "Change in the nature of activities",
          nameOfPartnership: "New Name of Partnership/Company",
          activitySector: "New Activity Sector",
          point1:
            "Attach a copy of the certificate of amendment issued by the competent authority (e.g. REQ, Corporations Canada)",
          point2:
            "Attach a copy of any declaration that has been filed with the competent authority concerning the change in the nature of activities and the name of the partnership/company",
        },
        section2: {
          title: "Sale of shares",
          to: "To:",
          nameOfMember: "Name of ODQ Member or Legal Entity",
          neq: "NEQ (If Applicable)",
          area1: {
            title: "Will you continue to practise dentistry?",
            yes: "Yes, as:",
            employee: "Employee",
            selfEmployedWorker: "Self-employed worker",
            clinicName: "Name of Clinic",
            addressName: "Address of Clinic",
            owner: "Owner",
            no: "No (Please contact the Order to update your status on the Roll of members)",
          },
          area2: {
            title:
              "Did you transfer patient files as part of this transaction?",
            yes: "Yes (You must complete the agreement between dentists for transferring files – see the “Members” section of www.odq.qc.ca)",
            yesHtml:
              "Yes (You must complete the <span class='font-weight-bold'>agreement between dentists for transferring files</span> – see the “Members” section of www.odq.qc.ca)",
            no: "No. Please explain:",
          },
        },
        section3: {
          title: "Short-form / long-form amalgamation",
          notes:
            "Following an amalgamation, the representative of an authorized partnership or company that is automatically cancelled after the amalgamation must submit a declaration of end of practice as a partnership or company to the Order.",
          noForm: "No amalgamation",
          shortForm: "Short-form amalgamation",
          longForm: "Long-form amalgamation",
          resultingPartnership: "Resulting partnership/company:",
          resultingPartnershipNeq: "New NEQ",
          point1:
            "Attach a copy of the certificate of amalgamation issued by the REQ or any other competent authority",
          point2:
            "Attach a copy of any amending declaration or updating declaration attesting to the amalgamation and filed with the REQ or any other competent authority",
          attestation: {
            title: "ATTESTATION",
            representative: "REPRESENTATIVE (FIRST NAME, LAST NAME)",
            permitNumber: "PERMIT NUMBER",
            note: "attest that the information provided in this declaration is accurate.",
          },
        },
      },
      amalgamation: {
        menuTitle: "Amalgamation",
        title: "Declaration of Short-Form Amalgamation",
        documentUploadWarning:
          "<span class='text-danger font-weight-bold'>IMPORTANT: in section 8, below, you must upload a copy of any documentation filed with the Registraire des entreprises du Québec (REQ) or Corporations Canada (ISDE Canada), in order to declare the amalgamation transaction, including a copy of the Certificate of amalgamation issued by said authority.</span>",
        section1: {
          titleNote:
            "<h5 class='d-inline'><b>FOR ANY OTHER CHANGE, AMENDMENT OR TRANSACTION</b></h5> affecting your partnership or company, you must notify the Order and complete the appropriate form within the prescribed time limits.",
          declaration: "<b>Declaration of short-form amalgamation</b>",
          annualDeclaration:
            "<b>Annual declaration of amalgamation as at March 31</b>",
          noteDeclaration: "<span class='text-danger pl-4'>(NO FEES)</span>",
          noteAnnualDeclaration:
            "<span class='text-danger pl-4'>(ATTACH A CHEQUE FOR ADMINISTRATIVE FEES)</span>",
        },
        section2: {
          title:
            "<b>PARTNERSHIP OR COMPANY RESULTING FROM THE AMALGAMATION</b>",
          PartnershipCompanyName: "Name of the Resulting Partnership / Company",
          QuebecEnterpriseNumber: "Quebec Enterprise Number (NEQ)",
          dateAmalgamation: "Date of Amalgamation",
          amalgamationOf: {
            title: "<b>AMALGAMATION OF:</b>",
            namePartnershipCompany: "Name of Partnership / Company",
            QuebecEnterpriseNumber: "NEQ",
            addPartnershipCompany: "Add Other Partnership or company",
          },
        },
        section3: {
          title: "<b>ATTESTATION</b>",
          reprisentative: "REPRESENTATIVE / SUBST ITUTE REPRESENTATIVE",
          permitNumber: "PERMIT NUMBER",
          i: "I,",
          attestVerified:
            "Attest that I have verified the accuracy of the information provided since my previous declaration.",
          attestConfirm:
            "Attest and confirm that as at this date, <span class='font-weight-bold'>no other</span> change has been made to my partnership/company since my previous declaration, in accordance with the Regulation respecting the practice of the dental profession within a limited liability partnership or a joint-stock company.",
          address: {
            title:
              "<span class='text-danger font-weight-bold'>TO BE COMPLETED ONLY FOR A CHANGE OF ADDRESS IN THE HEAD OFFICE OF THE PARTNERSHIP/COMPANY</span>",
            addressTitle: "NEW HEAD OFFICE ADDRESS",
            note: "N.B.: The head office address must match the address in the Registre des entreprises du Quebec (www.registreentreprises.gouv.qc.ca).",
          },
        },
      },
    },
    home: {
      menu: "Home",
      title: "Home — Portal of the Ordre des dentistes du Québec",
      intro1:
        "Welcome to the portal reserved for members of the Ordre des dentistes du Québec.",
      intro2:
        "From this portal you can fill out your declarations with the College, make changes and more.",
      intro3:
        "In order to meet your obligations for the year {{<b>years</b>}}, you must complete the following forms and pay the required amounts BEFORE <b>April 1st {{currentYear}}</b>",
      intro4:
        "Depending on your professional profile in our systems as of {{currentDate}}, here are the different forms to fill out.",
      dentoform: "Dentoform",
      inscription: "2026-2027 Annual registration",
      inscriptionUrl: "https://net.odq.qc.ca/cotisation/login.aspx?la=A",
      subscription:
        "Contribution to the Professional Liability Insurance Fund 2026-2027",
      retreiveIdentificationCode:
        "Recover your ID code/You need to reset your password",
      annualRegistration:
        "Annual registration and dues to the Ordre des dentistes du Québec",
      subscriptionFARPODQ:
        "Subscription to the Liability Insurance Fund of the Ordre des dentistes du Québec",
      annualDeclaration:
        "Annual declaration relating to your partnership or joint-stock company registered in the register of the Order",
      memberNotRegisterForCurrentPeriod:
        "You do not have a partnership registered with the Order for this period, so you do not have to fill out a form.",
      exerciseStatusInactive:
        "Your status is inactive for this period, so you do not have to subscribe to the Insurance Fund..",
      inscriptionStatusNoRegister:
        "You are not registered for this period, you do not have to take out insurance.",
      inscriptionStatusActifAndExempted:
        "You are active but you have an insurance exemption for this period, you do not have to take out insurance.",
      fillFormula: "Please fill out the form by clicking here",
      createDentalAssistantAccount: "Create a dental assistant account",
      payment: "Pay an invoice",
      paymentForm: {
        title: "Invoice Information",
        billNumber: "Invoice Number",
        payerName: "First and last name on the invoice",
        amount: "Total Invoice Amount",
        search: "Search",
        found: "Invoice Found",
        searchAnother: "Search Another Invoice",
        notFoundMessage: "We cannot find an unpaid invoice with the information you provided. Please verify your information and try again.",
        payment: "Payment",
        date: "Date",
        searchTitle: "Search for your invoice",
        mandatoryFields: "All three fields are mandatory and must exactly match the information appearing on your invoice.",
        hints: {
          billNumber: "Enter the full number appearing on your invoice.",
          payerName: "Enter the first and last name appearing in the 'Billed to' section of your invoice.",
          amount: "Enter the total amount shown on the invoice, including taxes."
        },
        importantInfo: {
          title: "Important information",
          intro: "This section allows you to pay invoices issued by the various departments of the Ordre des dentistes du Québec.",
          payableTitle: "Invoices that can be paid here",
          payableTitleShort: "You can pay here:",
          notPayableTitleShort: "Cannot be paid here:",
          payableDepartments: "Invoices from all departments of the Ordre des dentistes du Québec.",
          payableFarpodqRecovery: "Settlment invoices from the Professional Liability Insurance Fund (FARPODQ).",
          payableTraining: "Training courses and activities of the Ordre.",
          payableOtherServices: "Other administrative services of the Ordre.",
          notPayableTitle: "Invoices that cannot be paid here",
          notPayableFarpodq: "Invoices from the Professional Liability Insurance Fund (FARPODQ).",
          notPayableRegistration: "Annual registration on the Ordre's Roll.",
          notPayableMembershipFee: "Annual membership fee to the Ordre.",
          notPayableAnnualDeclaration: "The annual declaration relating to your company.",
          footer: "For these procedures, please use the forms available in the corresponding sections of the portal."
        },
        about: {
          title: "About this search",
          intro: "This section allows you to find and pay an invoice issued by the Ordre des dentistes du Québec.",
          requirements: "To perform a search, you must provide:",
          billNumberDesc: "The unique number assigned to your invoice.",
          payerNameDesc: "Enter the first and last name exactly as they appear in the 'Billed to' section of your invoice.",
          amountDesc: "The total amount due, including taxes.",
          tipTitle: "Tip",
          tipDesc: "All three fields must be completed. The information entered must match the details on your invoice exactly to enable the search."
        },
        invoiceFound: {
          matchMessage: "An invoice matching the entered information has been found.",
          verifyMessage: "Please verify the details below before proceeding with the payment."
        },
        summary: {
          title: "Invoice summary",
          subtotal: "Subtotal",
          tps: "GST",
          tvq: "QST",
          totalDue: "Total due"
        },
        securePayment: {
          title: "Secure payment",
          message: "Payment information is transmitted securely in accordance with industry standards.",
          noCardStorage: "No credit card information is stored by the Ordre des dentistes du Québec."
        },
        paymentInfo: {
          title: "Payment information",
          cardholderName: "Cardholder's name",
          cardholderNamePlaceholder: "Cardholder's name",
          cardholderNameHint: "Enter the name exactly as it appears on your card.",
          importantTitle: "Important",
          importantMessage: "All three fields are mandatory and must match the information on your card exactly.",
          invoiceVerified: "I have verified the invoice information.",
          chargeAuthorized: "I authorize the charge of the amount indicated above.",
          pay: "Pay {{amount}}",
          back: "Back"
        },
        confirmation: {
          title: "Payment successful",
          processed: "Your payment has been successfully processed.",
          invoicePaid: "Your invoice is now paid.",
          amountPaid: "Amount paid",
          invoiceCard: {
            title: "Invoice paid",
            number: "Invoice number",
            date: "Invoice date",
            description: "Description"
          },
          receiptCard: {
            title: "Moneris transaction receipt",
            transactionId: "Transaction ID",
            dateTime: "Transaction date and time",
            cardType: "Card type",
            cardNumber: "Card number",
            authorization: "Authorization number"
          },
          checks: {
            invoicePaid: "Invoice paid",
            authorized: "Transaction authorized by the financial institution",
            authorizedShort: "Transaction authorized",
            noAction: "No further action required"
          },
          thankYou: "Thank you. Please keep this information for your records.",
          actions: {
            anotherPayment: "Make another payment",
            home: "Return to home",
            print: "Print receipt"
          }
        }
      }
    },
    individual: {
      title: "Individual",
      fields: {
        firstname: "First name",
        lastname: "Last name",
      },
    },
    profile: {
      language: "EN",
      welcome: "Welcome",
      settings: "Settings",
      disable_notifications: "Disable notifications",
      sign_in: "Sign In",
      sign_out: "Sign Out",
      resetPassword: "Forgot your password",
      sessionExpiring: {
        line1: "Your session expire in {{timeLeft}} minutes.",
        line2: "Finish your work before this deadline and renew to continue.",
      },
      renew: "Renew",
    },
    version: {
      labelBeforeAnchor:
        "A new version {{latestVersion}} exists, please click ",
      labelAnchor: "here",
      labelAfterAnchor: " to reload the page",
    },
    mailbox: {
      title: "You have {{count}} new Mymessages",
    },
    messages: {
      menuTitle: "Secure messages",
    },
    secureMessages: {
      title: "Secure messages",
      intro:
        "Read the secure messages addressed to you here. These messages may contain important information about your claims, your coverage or any other confidential communication.",
      comingSoon: "Coming soon",
      groups: {
        insuranceFund:
          "Professional liability insurance fund of the Ordre des dentistes du Québec",
        orderOfDentists: "Ordre des dentistes",
      },
      categories: {
        claims: "Claims",
        communication: "Communication",
        admission: "Admission / Board",
        practiceInCompany: "Practice in a company",
        inspection: "Professional inspection",
        syndic: "Syndic",
        continuingEducation: "Continuing education",
        other: "Other communications",
      },
    },
    company: {
      selectActiveCompany: "Select your active Partnership or Company",
      fields: {
        id: "Id",
        name: "Name",
      },
      formState: {
        noForm: "The company has no form available",
        modify: "Modify",
        viewSummary: "View Summary",
        status: {
          Initial: "Not started",
          InProgress: "In Progress",
          Completed: "Completed",
          undefined: "Initialization in progress - please wait",
          Payed: "Payed",
        },
      },
    },
    shoppingCart: {
      title: "Shopping Cart",
      empty: "Your cart is empty",
      cartItem: {
        title: "Title",
        description: "Description",
        quantity: "Quantity",
        total: "Total",
      },
      payment: {
        creditCardNumber: "Credit Card Number",
        expirationDate: "Expiration Date (MMYY)",
        proceedWithPayment: "Proceed with payment",
        modern: {
          frameTitle: "Credit card information",
          cardNumber: "Card number *",
          expirationDate: "Expiration date (MM/YY) *",
          securityCode: "Security code (CVC) *",
          cardNumberShort: "Card number:",
          cardNumberHint: "Enter your Visa or Mastercard number.",
          expirationDateShort: "Expiration date:",
          expirationDateHint: "Enter the expiration date shown on your card.",
          securityCodeShort: "Security code:",
          securityCodeHint: "3-digit code on the back of your card."
        },
        error: {
          title: "Payment Error",
          code: "Error Code",
          unProcessedPayment: "Payment has not been made.",
          940: "Invalid profile id (on tokenization request)",
          941: "Error generating token",
          942: "Invalid Profile ID, or source URL",
          943: "Card data is invalid (not numeric)",
          944: "Invalid expiration date (mmyy, must be current month or in the future)",
          945: "Invalid CVD data (not 3-4 digits)",
          51: "Transaction refused",
        },
      },
      checkout: {
        title: "Payment",
        amountToPay:
          "The amount of {{amount}}$ will be charged to the credit card.",
        studentAmountToPay:
          "The system has identified an invoice corresponding to the information provided. Please provide your payment information. A charge of {{amount}}$ will be made to your credit card to complete the payment of the invoice",
          warning:
          "<ul class='mt-4'><li><P>Required fees <span class='font-weight-bold'>CAN ONLY BE PAID ONLINE</span> by Visa or MasterCard</P></li><li><P>The fees required :</P><ul><li class='font-weight-bold'>$300/company NOT OPERATING <span class='text-danger'>ANY</span> establishment or OPERATING <span class='text-danger'>A SINGLE</span> establishment</li><li class='font-weight-bold'>$300/additional establishment <span class='text-danger'>OPERATED</span> by the company</li></ul></li></ul>",
        transactionDetails: {
          title: "Transaction Details",
          item: "{{title}} @ {{price}}$ each",
        },
      },
      receipt: {
        pdfGenerating:
          "Please wait while we are generating the final version of your summary",
        title: "Receipt",
        subject:
          "We have received your payment for the {{payment_a}} {{payment_b}}.",
        amountCC:
          "The amount of <span class='font-weight-bolder'>{{amount}}$</span> will be charged to the credit card account {{cc}}",
        invoice: "Invoice",
        transactionReference: "Online Transaction Reference",
        repondant: "Representative",
        societe: "Company",
        fileNumber: "File number",
        reference: {
          transactionType: "Transaction type",
          orderId: "Order ID",
          dateTime: "Date/Time",
          sequenceNumber: "Sequence Number",
          message: "Message",
          amount: "Amount",
          approvalCode: "Approval code",
          responseCode: "Response/ISO Code",
        },
        refundPolicy: {
          title: "Refund Policy",
          detail: "No refund.",
        },
        ODQAddress: {
          odq: "Ordre des dentistes du Québec (ODQ)",
          line1: "800 René-Lévesque West, suite 1640",
          line2: "Montréal (Québec) H3B 1X9",
        },
      },
      nextStep: "Next Step",
    },
    memberCard: {
      title: "Member card",
    },
    studentCard: {
      title: "Student card",
    },
    addresses: {
      title: "Manage addresses",
    },
    inscription: {
      title: "Inscription",
      yearSelection: {
        formForYear: "Form for year",
        fillForm: "Fill the form",
        downloadForm: "Download the form",
        formSubmitted: "Your form has been submitted.",
        pdfNotAvailable:
          "Your PDF recap will be available within the next 24 business hours",
        notOpenedYet: "The form is not opened yet.",
        noFormAccess: "Access to the form is disabled.",
      },
    },
    bills: {
      title: "Receipts",
    },    
    invoices: {
      title: "Invoices",
    },
    billsAndInvoices: {
      title: "Receipts/Invoices",
    },
    farpSubscription: {
      title: "Farp Subscription",
    },
    professionalServices: {
      title: "Proffesional Inspection",
      links: {
        surveysToComplete: "Surveys to complete",
        surveysHistory: "Surveys History",
        documentsToShare: "Documents",
      },
    },
    generalPublic: {
      title: "General Public",
      titleSharedProjects: "Shared Projects",
      sharedProjects: {
        description: "Description",
        startDate: "Start Date",
        endDate: "End Date",
        name: "Project Name"
      }
    },
    formation: {
      information: {
        paragraph1: "",
        paragraph2: "",
        paragraph3: "",
      },
      action: {
        addActivity: "Declare an activity",
        updateActivityInformation: "Update activity information",
        updateActivityDeclaredUFC: {
          title: "Update declared CEU units",
          message: "Declared CEU units succesfully updated",
        },
        updateActivityApprovedUFC: "Update approved CEU units",
        removeActivity: "Remove activity",
        removeActivityToaster: {
          title: "Activity removal",
          message: "Activity was successfully removed",
        },
        RemoveDocument: "Remove document",
        addDocument: "Add document",
      },
      title: "Continuing education",
      continuingEducation: "Continuing education",
      referencePeriod: "Reference Period",
      noReferencePeriods: "No reference period available",
      exportPdf: "Export the period",
      dialog: {
        add: "Add",
        update: "Update",
        confirmRemoval: "Are you sure you want to remove this activity",
        addActivity: {
          referenceYear: "Reference year",
          date: "Date of activity or completion of activity",
          category: "Category",
          establishment: "Establishment / Education centre",
          establishmentName: "Name of the establishment / Education centre",
          etsActivitiesLabel: "Activities of the establishment on",
          otherNotInList: "Other activity that is not in the list",
          establishmentHelpMessage:
            "Type the first letters of the name of the  establishment or education center, then select one from Establishment / Education centre dropdown list. To add an establishment/education centre that is not in the list, click on « Other establishment » at the bottom of the list.",
          dentoformNotice:
            "Starting October 1, 2024, activities followed on Dentoform will be automatically recorded in your register. Activities completed before this date will need to be added manually.",
          jdiqCenterNotice:
            "Starting May 29, 2025, activities from the Journées dentaires internationales du Québec (JDIQ) will be automatically recorded in your register. Activities completed before this date will need to be added manually.",
            odqCenterNotice: "Dentoform training courses from the Order of Dentists are automatically declared in the register. To declare an activity of the Journées dentaires internationales du Québec, select it from the drop-down list.",
            activity: {
            adaCerpFlag: "Recognized ADA-CERP",
            title: "Activity title",
            subject: "Topic, area or title",
            description: "Description / Other information",
            date: "Date",
            dateOfCompletion: "Date of activity completion",
            theoreticalDuration: "Duration in hours",
            practicalDuration: "Practical workshop duration",
            trainingDuration: "Training duration",
            startAt: "Starting at",
            endAt: "Ending at",
            duration: "Duration in hours",
            sessionType: "Type of session",
            declaredUfcPoints: "Declared CEU units",
            ufcPoints: "Declared CEU units",
            uploadFileTitle: "Upload a file",
            uploadFileMessage:
              "Files are only uploaded when clicking the Save button in the window",
            uploadFile: "Upload a file",
            depositFile: "Deposit file",
          },
          addDocumentDialog: {
            title: "Add document",
          },
          OTHER: "Other establishment",
          toaster: {
            title: "Activity added",
            message: "Activity was succesfully added",
          },
        },
        updateDeclaredUfc: {
          oldValue: "Old value",
          newValue: "New value",
        },
      },
      sessionType: {
        Theoretical: "Lecture",
        Practical: "Practical",
        Discussion: "Discussion",
      },
      stats: {
        ufcPerYearTitle: "Minimum units per year",
        ufcPerPeriodTitle: "CEU per period",
        ufcOrgsRecognized: "Recognized centers",
        ufcOrgsNotRecognized: "Other centers",
        ufcNotCounted: "units excluded",
        ufcOrgsRecognizedTodDo: "Recog. units to do",
        ufcOrgsNotRecognizedTodDo: "Other center units to do",
        recognizedRequired: "Required credit from recognized center",
        totalRequired: "Total units required",
        ufcThreePoints: "Specific units",
      },
      list: {
        date: "Date",
        activityName: "Activity title",
        activityCategory: "Activity category",
        establishment: "Organism / establishment",
        odqApproved: "Organism / establishment ODQ approved",
        odqApprovedFlag: {
          NA: "Not available",
          Recognized: "Recognized",
          NotRecognized: "Not recognized",
        },
        declaredUFCpoints: "declared CEU units",
        approvedUFCpoints: "Recognized CEU units",
        notRecognizedUFCpoints: "Other centers CEU units",
        UFCRefusalExplanation: "Explanation for CEU refusal",
        action: "Action",
        noData: "No data",
        from: "From",
        to: "to",
        hours: "Hours",
      },
      noDataError: {
        title: "No available data",
        message:
          "No data associated with your account, please contact your administrator.",
      },
      address: {
        search: {
          label: "Address",
          placeholder: "Start typing your address...",
        },
        line1: "Address line 1",
        line2: "Address line 2",
        buildingNumber: "No",
        street: "Street",
        city: "Municipality / City / Town",
        province: "Province / State",
        postalCode: "Postal Code",
        country: "Country",
        noMatch: "No match? Enter the address manually.",
        searchError:
          "We cannot reach Canada Post at this moment. Please enter the address manually or try again later. Contact support if the problem persists.",
      },
    },
    forgetPassword: {
      firstStep: "Enter the information required",
      secondStep: "Validate the information",
      permitNumber: "Permit number",
      birthDate: "Birth date",
      email: "Please confirm the email address",
      day: "Day",
      month: "Month",
      year: "Year",
      next: "Next",
      previous: "Previous",
      done: "Done",
      step1Error:
        "The entered information does not match the informations appearing in your file",
      step2Error:
        "The entered email address does not match the one appearing in your file",
      invalidEmail:
        "The entered address is different than the one in the system",
      invalidBirthDate: "Birth date is invalid",
      invalidDay: "Day must be between 1 and 31",
      invalidMonth: "Month must be between 1 and 12",
      invalidYear: "Year must be higher than 1800",
      emailConfirmation:
        "The identification code has been sent to the specified email address",
      closePage: "Close page",
    },
    footer: {
      copyright:
        "© All rights reserved {{year}} - Ordre des dentistes du Québec",
      links: {
        contactUs: "Contact",
        confidentialityAgreement: "Privacy",
        termsOfUse: "Conditions",
      },
    },
    legalEntity: {
      title: "Partnership or Company",
    },
  },
};
